<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div class="text-xs-right">
          <v-btn color="primary" @click="onRegister">
            New Stock In
            <v-icon right>add_circle</v-icon>
          </v-btn>
          <v-btn color="primary" @click="openDialog=true">Import Stock In</v-btn>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4 v-if="user.role.roleName == 'ADMIN' || user.role.roleName == 'BRANCH_ADMIN'">
              <v-select
                :items="warehouseList"
                label="Choose Warehouse..."
                item-text="name"
                menu-props="auto"
                item-value="id"
                v-model="queryParams.warehouseId"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="stockInStatusList"
                label="Choose Stock In Status ..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="label"
                item-value="value"
                menu-props="auto"
                v-model="queryParams.status"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="queryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field name="poNo" label="Po No" type="text" v-model="queryParams.poNo"></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex d-flex xs12>
        <v-card>
          <v-card-text class="font-weight-bold">
            <div>
              <v-btn
                :loading="printAllButtonLoading"
                color="primary"
                @click="printAllStockIn('printStockIn')"
              >PRINT ALL</v-btn>
              <v-btn
                :loading="printAllButtonLoading"
                color="success"
                @click="exportAllStockIn()"
              >EXPORT ALL</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="stockInList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.warehouse.name }}</td>
              <td>{{ props.item.issueDateInMilliSeconds | format-ms-date}}</td>
              <td>{{ props.item.issueNo }}</td>
              <td>{{ props.item.poNo }}</td>
              <td>{{ props.item.status }}</td>
              <td>{{ props.item.description }}</td>
              <td>{{ props.item.updatedDateInMilliSeconds | format-ms-date-time }}</td>
              <td>{{ props.item.updatedBy }}</td>
              <td>
                <v-btn flat icon color="blue lighten-2" @click="onEdit(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- dialog -->
    <stockInExcel :isOpen="openDialog" v-on:change="dialogClose()"></stockInExcel>
    <!-- print section -->
    <div id="printStockIn" style="bsale:1px solid black;width:300px;" v-show="false">
      <div style="text-align:center">
        <p style="font-size:18px;margin:1px">Stock In Report</p>
      </div>
      <br />
      <div style="padding-left:5px;padding-right:5px">
        <table
          style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;border-top:1px solid black"
        >
          <span v-for="(item, index) in allStockInList" :key="index">
            <thead style="border-bottom:1px solid black;border-top:1px solid black">
              <tr>
                <th style="text-align:left">Warehouse Name</th>
                <th style="text-align:left">Issue Date</th>
                <th style="text-align:left">Issue No</th>
                <th style="text-align:left">Stock In Status</th>
                <th style="text-align:left">Description</th>
                <th style="text-align:left">Updated Date</th>
                <th style="text-align:left">Updated By</th>
              </tr>
            </thead>
            <tbody>
              <tr style="border-bottom:1px solid black;">
                <td>{{ item.warehouse.name }}</td>
                <td>{{ item.issueDateInMilliSeconds | format-ms-date}}</td>
                <td>{{ item.issueNo }}</td>
                <td>{{ item.status }}</td>
                <td>{{ item.description }}</td>
                <td>{{ item.updatedDateInMilliSeconds | format-ms-date-time }}</td>
                <td>{{ item.updatedBy }}</td>
              </tr>
              <tr style="border-bottom:1px solid black;">
                <th style="text-align:left;">Stock In Items</th>
                <td colspan="4">
                  <table
                    style="font-family: arial, sans-serif;width: 100%;font-size:11px;border:1px solid black"
                  >
                    <thead style="border-bottom:1px solid black;border-top:1px solid black">
                      <tr>
                        <th style="text-align:left">Code</th>
                        <th style="text-align:left">Product Name</th>
                        <th style="text-align:left">Unit</th>
                        <th style="text-align:left">Qty</th>
                        <th style="text-align:left">Unit Cost</th>
                        <th style="text-align:left">Selling Price</th>
                        <th style="text-align:left">Remark</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(detailItem, index) in item.stockInItems" :key="index">
                        <td style="text-align:left">{{detailItem.productCode}}</td>
                        <td style="text-align:left">{{detailItem.productName}}</td>
                        <td style="text-align:left">{{detailItem.factorUnitName}}</td>
                        <td style="text-align:left">{{detailItem.qty}}</td>
                        <td style="text-align:left">{{detailItem.unitCost}}</td>
                        <td style="text-align:left">{{detailItem.sellingPrice}}</td>
                        <td style="text-align:left">{{detailItem.remark}}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr style="height: 10px;">
                <td colspan="5"></td>
              </tr>
            </tbody>
          </span>
        </table>
      </div>
    </div>
  </v-container>
</template>

<script>
import { stockInService } from "../../services/stockin-service";
import { warehouseService } from "../../services/warehouse-service";
import { commonService } from "../../services/common-service";
import stockInExcel from "../../components/stockin/StockInExcel";

export default {
  name: "StockInList",

  components: { stockInExcel },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    issueDate: "",
    breadcrumbs: [
      {
        text: "General",
        disabled: true
      },
      {
        text: "StockIn",
        disabled: true
      }
    ],
    headers: [
      { text: "Warehouse Name", align: "left", value: "warehouse.name" },
      { text: "Issue Date", value: "issueDate" },
      { text: "Issue No", value: "issueNo" },
      { text: "PO_NO", value: "poNo" },
      { text: "Stock In Status", value: "status" },
      { text: "Description", value: "description" },
      { text: "Updated  Date", value: "updatedDate" },
      { text: "Updated  By", value: "updatedBy" },
      { text: "Action", value: "name", sortable: false }
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0
    },
    stockInStatusList: [
      { label: "----All----", value: "" },
      { label: "DRAFT", value: "DRAFT" },
      { label: "FINISHED", value: "FINISHED" },
      { label: "CANCEL", value: "CANCEL" }
    ],
    stockInList: [],
    allStockInList: [],
    warehouseList: [],
    openDialog: false,
    printAllButtonLoading: false,
    totalRows: 0,
    queryParams: {
      warehouseId: "",
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueNo: "",
      poNo: "",
      status: ""
    }
  }),
  watch: {
    pagination: {
      handler() {
        this.getStockInList();
      },
      deep: true
    }
  },
  created() {
    let user = JSON.parse(localStorage.getItem("user"));
    if (user.role.roleName == "WAREHOUSE_MANAGER") {
      this.queryParams.warehouseId = user.warehouseId;
    }
    //for deep linking
    if (this.$route.query.warehouseId) {
      this.queryParams.warehouseId = this.$route.query.warehouseId;
    }
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.issueNo) {
      this.queryParams.issueNo = this.$route.query.issueNo;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getWarehouseList();
    this.getStockInList();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "stockins", query: this.queryParams });
      this.getStockInList();
    },
    getWarehouseList() {
      warehouseService
        .getAllWarehouse("ACTIVE")
        .then(res => {
          this.warehouseList = res.data;
          let findAll = {
            id: "",
            name: "----All----"
          };
          this.warehouseList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
        });
    },
    getStockInList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      stockInService
        .getStockInList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.stockInList = res.data.stockInList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/stockin/new");
    },
    printAllStockIn(divName) {
      this.printAllButtonLoading = true;
      stockInService
        .getAllStockInList(this.queryParams)
        .then(res => {
          if (res.data) {
            this.allStockInList = res.data.stockInList;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.printAllButtonLoading = false;
        });
    },
    dialogClose() {
      this.openDialog = false;
      this.getStockInList();
    },
    onEdit(stockin) {
      // go to details page
      this.$router.push("/stockin/" + stockin.id);
    },
    exportAllStockIn() {
      this.printAllButtonLoading = true;
      stockInService
        .exportStockInExcel(this.queryParams)
        .then(res => {
          commonService.downloadE(res);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.printAllButtonLoading = false;
        });
    }
  }
};
</script>

